import {Outlet} from 'react-router-dom';
import styles from './navigation.module.scss';
import {CenteredSpinner} from '../spinner/centered_spinner';
import {Suspense} from 'react';
import {MobileNavigation} from './mobile_navigation.tsx';
import {DesktopNavigation} from './desktop_navigation.tsx';

export type NavLinkRenderProps = {
    isActive: boolean;
    isPending: boolean;
    isTransitioning: boolean;
};

export function navLinkClass({isActive, isPending}: NavLinkRenderProps) {
    return styles.menu__item + ' ' + (isActive ? styles.active : isPending ? styles.pending : '');
}

export function Navigation() {
    return (
        <>
            <MobileNavigation />
            <DesktopNavigation />

            <Suspense fallback={<CenteredSpinner />}>
                <Outlet />
            </Suspense>
        </>
    );
}
